import React, { Component } from 'react';
class PaymentSuccess extends Component {
    state = {  }
    render() { 
        return ( 
            <div style={{textAlign: 'center', margin: '50px'}}>
                <h1><u>Payment Success</u></h1>
                <h4>Start using your new hosting plan now.</h4>
            </div>
         );
    }
}
 
export default PaymentSuccess;